import { ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute } from "@angular/router";
import { DomSanitizer } from '@angular/platform-browser';
import { LayoutPrintFormService } from "./layout-print-form.service";
import { Router } from "@angular/router";
var LayoutPrintFormComponent = (function () {
    function LayoutPrintFormComponent(route, sanitizer, layoutPrintFormService, toastr, vcr, router) {
        this.route = route;
        this.sanitizer = sanitizer;
        this.layoutPrintFormService = layoutPrintFormService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.selectedQrCode = {};
        this.css = '';
        this.nameLayout = '';
        this.size = 'big';
        this.toastr.setRootViewContainerRef(vcr);
        this.configCss = {
            '.layout-print': {
                'width': { value: [10.3], unit: 'cm' }
            },
            '.item-sm': {
                'width': { value: [5], unit: 'cm' },
                'height': { value: [4], unit: 'cm' },
                'padding': { value: [0.5, 0, 0.5, 0], unit: 'cm' }
            },
            '.item-lg': {
                'width': { value: [5], unit: 'cm' },
                'height': { value: [5], unit: 'cm' },
                'padding': { value: [0.5, 0, 0.5, 0], unit: 'cm' }
            },
            '.info-sm': {
                'font-size': { value: [10], unit: 'pt' },
                'line-height': { value: [0.85], unit: '' },
            },
            '.info-lg': {
                'font-size': { value: [12], unit: 'pt' },
                'line-height': { value: [1], unit: '' },
            },
            '.sub-info-lg': {
                'font-size': { value: [12], unit: 'pt' },
                'height': { value: [0.5], unit: 'cm' },
                'line-height': { value: [0.9], unit: '' }
            },
            'qrcode-sm': { value: [1.6], unit: 'cm' },
            'qrcode-lg': { value: [1.9], unit: 'cm' }
        };
    }
    LayoutPrintFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.title = 'Edit Layout Print';
        this.route.paramMap.subscribe(function (params) {
            _this.idLayout = params.get('id');
            if (_this.idLayout === 'create') {
                _this.title = 'Create Layout Print';
            }
            else {
                _this.getLayoutPrintById();
            }
        });
        this.sizeQrcode = [];
        for (var i = 10; i <= 30; i++) {
            this.sizeQrcode.push(i / 10);
        }
        this.initData();
        this.renderCss();
    };
    LayoutPrintFormComponent.prototype.initData = function (className) {
        if (className === void 0) { className = ''; }
        this.printData = [];
        for (var i = 0; i < 4; i++) {
            this.printData.push(JSON.parse("{\"formatCode\":\"GWN2KNBV5SUT-SJLI46SL7-FFD97AA955C84C0DAB4695BBA25ADE200F7A3463\",\"productId\":\"GW-GUN-V1\",\"serialId\":\"GWN2KNBV5SUT\",\"noId\":\"SJLI46SL7\",\"hmac\":\"FFD97AA955C84C0DAB4695BBA25ADE200F7A3463\",\"numberPerCode\":10,\"description\":\"Goodwill safes\",\"createdAt\":1521479037000,\"used\":true}"));
        }
        if (className != '') {
            this.selectedQrCode = {
                name: className == 'item-sm' ? 'Small QRCode' : 'Big QRCode',
                class: '.' + className,
                classInfo: className == 'item-sm' ? '.info-sm' : '.info-lg'
            };
        }
    };
    LayoutPrintFormComponent.prototype.renderCss = function (attr, value) {
        if (attr === void 0) { attr = ''; }
        if (value === void 0) { value = 0; }
        switch (attr) {
            case 'width':
                {
                    this.configCss['.item-sm']['width'].value[0] = this.configCss['.item-lg']['width'].value[0] = value;
                }
                break;
        }
        this.configCss['.layout-print']['width'].value[0] = 2 * this.configCss['.item-sm']['width'].value[0] + 0.3;
        this.css = '';
        for (var key1 in this.configCss) {
            if (key1 === 'qrcode-sm' || key1 === 'qrcode-lg') {
                continue;
            }
            var temp = '';
            for (var key2 in this.configCss[key1]) {
                if (this.configCss[key1][key2].value && this.configCss[key1][key2].value.length == 1) {
                    temp += "\n          " + key2 + ": " + this.configCss[key1][key2].value + this.configCss[key1][key2].unit + ";";
                }
                if (this.configCss[key1][key2].value && this.configCss[key1][key2].value.length == 4) {
                    temp += key2 + ": " + this.configCss[key1][key2].value[0] + this.configCss[key1][key2].unit + " " + this.configCss[key1][key2].value[1] + this.configCss[key1][key2].unit + " " + this.configCss[key1][key2].value[2] + this.configCss[key1][key2].unit + " " + this.configCss[key1][key2].value[3] + this.configCss[key1][key2].unit + ";";
                }
            }
            this.css += "\n      " + key1 + " {" + temp + "\n      }";
        }
        this.style = this.sanitizer.bypassSecurityTrustHtml('<style>' + this.css + '</style>');
    };
    LayoutPrintFormComponent.prototype.getLayoutPrintById = function () {
        var _this = this;
        this.isLoading = true;
        this.layoutPrintFormService.getLayoutPrint(this.idLayout)
            .then(function (res) {
            if (res.status === 1) {
                _this.layoutPrint = res.data;
                _this.configCss = JSON.parse(_this.layoutPrint.jsonCss);
                _this.nameLayout = _this.layoutPrint.name;
                _this.renderCss();
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
            _this.isLoading = false;
        }).catch(function (err) { return console.log(err); });
    };
    LayoutPrintFormComponent.prototype.saveLayoutPrint = function () {
        var _this = this;
        this.isLoading = true;
        switch (this.idLayout) {
            case 'create':
                {
                    var data = {
                        name: this.nameLayout,
                        jsonCss: JSON.stringify(this.configCss)
                    };
                    console.log(data);
                    this.layoutPrintFormService.createLayoutPrint(data)
                        .then(function (res) {
                        if (res.status === 1) {
                            _this.toastr.success(res.message, 'Success!');
                        }
                        else {
                            _this.toastr.error(res.message, 'Error!');
                            if (res.errorCode === 3000) {
                                localStorage.setItem("alert", JSON.stringify(res.message));
                                _this.router.navigate(['login']);
                            }
                        }
                        _this.isLoading = false;
                    }).catch(function (err) { return console.log(err); });
                }
                break;
            default:
                {
                    var data = {
                        id: this.layoutPrint.id,
                        name: this.nameLayout,
                        jsonCss: JSON.stringify(this.configCss)
                    };
                    this.layoutPrintFormService.editLayoutPrint(data)
                        .then(function (res) {
                        if (res.status === 1) {
                            _this.toastr.success(res.message, 'Success!');
                        }
                        else {
                            _this.toastr.error(res.message, 'Error!');
                            if (res.errorCode === 3000) {
                                localStorage.setItem("alert", JSON.stringify(res.message));
                                _this.router.navigate(['login']);
                            }
                        }
                        _this.isLoading = false;
                    }).catch(function (err) { return console.log(err); });
                }
                break;
        }
    };
    return LayoutPrintFormComponent;
}());
export { LayoutPrintFormComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print-form/layout-print-form.component.ts.pre-build-optimizer.js